
export class AuthConstants {

    static readonly ACCESS_TOKEN = 'access_token';

}
